module.exports = __webpack_public_path__ + "static/img/deve2.4ad2cb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deve2.png
// module id = Vj2T
// module chunks = 1